module.exports = __webpack_public_path__ + "img/cpsc.d50dd4b1.png";